const ModalLineAddColumn = ({ callback }) => {
  return (
    <div className={`modal-column-line-column-btn-add`}>
      <div className="modal-column-add" onClick={callback}>
        Add a field
      </div>
    </div>
  )
}

export default ModalLineAddColumn
